import { wpApiInstance} from '../api/wp-api';
import { apiRetry } from '../api/api-helper';

import { IUserSettings } from '../models/settings.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Function to get an individual user's settings
 * 
 * @returns {IUserSettings} the api response | error
 */
const GetUserSettings = async (): Promise<IUserSettings> => {
  try {
    apiRetry(wpApiInstance);

    const { data } = await wpApiInstance.get('/profile');

    return data;
  } catch (error ) {
    handleRouteError(error, 'Error getting customer data');
    throw(error);
  }
}

export default GetUserSettings;